import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        // if (!GameConstants.DEVELOPMENT) {
        //     this.sound.playAudioSprite("audio-sprite", "soundtrack_loop", {loop: true});
        // }
        
        GameManager.onGameAssetsLoaded();
    }
    
    private composeScene(): void {

        this.add.text(0, 60, "abcdefghijk", { fontFamily: "FuturaPTDemi", fontSize: "22px", color: "#FFFFFF"});
        this.add.text(0, 160, "abcdefghijk", { fontFamily: "FuturaPTMedium", fontSize: "22px", color: "#FFFFFF"});
        this.add.text(0, 260, "abcdefghijk", { fontFamily: "FuturaPTBold", fontSize: "22px", color: "#FFFFFF"});
        this.add.text(0, 360, "abcdefghijk", { fontFamily: "FuturaPTBook", fontSize: "22px", color: "#FFFFFF"});
   
        const background = this.add.graphics();
        background.fillStyle(0xFF0000);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        this.scaledItemsContainer.scaleY = GameVars.scaleY;

        const slLogo = new Phaser.GameObjects.Image(this, 0, -195, "sl_logo");
        this.scaledItemsContainer.add(slLogo);
        
        const preloadLabel = new Phaser.GameObjects.Image(this, 0, 150, "preload-label");
        preloadLabel.setScale(1.25);
        this.scaledItemsContainer.add(preloadLabel);
    
        const barWidth = 780;
        const barWHeight = 14;
        const borderWidth = 2;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0xb10400);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        this.scaledItemsContainer.add(preloadBarCapsuleBorder); 

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0xFFFFFF);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        preloadBarCapsule.x = - barWidth / 2;
        this.scaledItemsContainer.add(preloadBarCapsule); 

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0xF2CC4F);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        this.progressBar.x = - barWidth / 2;
        this.progressBar.scaleX = 0;
        this.scaledItemsContainer.add(this.progressBar); 
    }

    private loadAssets(): void {

        for (let i = 0; i < GameVars.prizeResults.prizes.length; i ++) {

            const prizeData = GameVars.prizeResults.prizes[i];
            const prizeImageURL = prizeData.image;

            if (prizeImageURL) {
                this.load.image("prize-image-" + prizeData.id, prizeData.image);
            }
        }

        this.load.bitmapFont("roboto-bold-red", "assets/fonts/roboto-bold-red.png", "assets/fonts/roboto-bold-red.xml");
        this.load.bitmapFont("roboto-bold-white", "assets/fonts/roboto-bold-white.png", "assets/fonts/roboto-bold-white.xml")
        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.audioSprite("audio-sprite", "assets/audio/audiosprite.json", ["assets/audio/audiosprite.mp3", "assets/audio/audiosprite.ogg"]);

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }
}
